import Vue from 'global-vue'
import moment from 'moment'

import userRoleFilter from 'app/filters/userRole'
import loggerStateFilter from 'app/filters/loggerState'
import loggerStateColorFilter from 'app/filters/loggerStateColor'
import loggerMutationTypeFilter from 'app/filters/loggerMutationType'
import loggerMutationTypeColorFilter from 'app/filters/loggerMutationTypeColor'
import repairStateFilter from 'app/filters/repairState'
import actionStateFilter from 'app/filters/actionState'
import actionStateColorFilter from 'app/filters/actionStateColor'
import actionDeadline from 'app/filters/actionDeadline'
import actionDeadlineDate from 'app/filters/actionDeadlineDate'
import userInitials from 'app/filters/userInitials'

export default class {

    run(){

        moment.locale('nl');

        Vue.filter('userRole', userRoleFilter);
        Vue.filter('userInitials', userInitials);
        Vue.filter('loggerState', loggerStateFilter);
        Vue.filter('loggerStateColor', loggerStateColorFilter);
        Vue.filter('loggerMutationType', loggerMutationTypeFilter);
        Vue.filter('loggerMutationTypeColor', loggerMutationTypeColorFilter);
        Vue.filter('repairState', repairStateFilter);
        Vue.filter('actionState', actionStateFilter);
        Vue.filter('actionStateColor', actionStateColorFilter);
        Vue.filter('actionDeadline', actionDeadline);
        Vue.filter('actionDeadlineDate', actionDeadlineDate);
    }
}